﻿export class ProductViewModelFactory {
  constructor(productType) {
    this.productType = productType;
  }

  createProductEditor(productEditorConfig, designerService, productService) {
  }

  /**
   * The materialIds object will be populated with properties matching the values in the finishes
   * array. Each property's value will be set to true.
   * @param {any} materialIds An object which will given additional properties by this method.
   * @param {any} prefix Prefix for the property names
   * @param {any} finishes An array of finish id's which will become property names on the materialIds parameter.
   */
  addMaterials(materialIds, prefix, finishes) {
    finishes.forEach(finish => materialIds[prefix + '-' + finish] = true);
  };

  getAllKnownProductMaterialIds(apiProduct) {
    return {};
  }

  createProduct(drawingService, apiProduct) {
  }
}

class ProductViewModelFactoryList {
  constructor() {
    this.factories = {};
    this.knownFactories = [];
  }

  get(productType, factoryClass, productClass) {
    let factory = this.factories[productType];
    if (!factory) {
      factory = this.factories[productType] = new factoryClass(productType, productClass);
    }
    return factory;
  }

  getFactory(productType) {
    let map = this.knownFactories[productType];
    if (!map) {
      map = this.knownFactories['FixedDesignerProduct'];
    }
    return this.get(productType, map.factoryClass, map.productClass);
  }

  createProduct(drawingService, apiProduct, config) {
    const factory = this.getFactory(apiProduct.type);
    return factory.createProduct(drawingService, apiProduct, config);
  }

  /**
   * Registers a map from product type to product view model factory (and optional product class).
   * @param {any} productType Must match the types specified in API products (product.type) returned
   * by the Langlo Store API on the LangloWeb (link.langlo.no) server.
   * @param {ProductViewModelFactory} factoryClass A subclass of ProductViewModelFactory.
   * @param {Component} productClass A subclass of Component.
   */
  register(productType, factoryClass, productClass) {
    this.knownFactories[productType] = { factoryClass, productClass };
  }
}

export const ProductViewModelFactories = new ProductViewModelFactoryList();
